import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { errorToast } from "../../../components/toastmessage/toastmessage";
import { fetchWardApiCall } from "./watchService";


const useWardTableHook = () => {
    const navigate = useNavigate();
    const [wardState, setWardState] = useState([]);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        const fetchWards = async () => {
            setLoader(true)
            try {
                let result = await fetchWardApiCall();
                if (result.status === 200) {
                    setLoader(false)
                    setWardState(result?.data?.result)
                }
            } catch (e) {
                setLoader(false)
                errorToast("Failed to fetch Rooms")
            }

        }
        fetchWards();

    }, []);

    const handleDelete = (e, id) => {
        e.preventDefault();
        setWardState(oldValues => {
            return oldValues.filter(room => room?.uniqueId !== id?.uniqueId)
          });
    };

    const handleGetRowId = (e) => {
        return e?.uniqueID
    }

    const handleAddWard = () => {
        navigate("/master/add-ward")
    }
    return {
        loader,
        wardState,
        handleGetRowId,
        handleDelete,
        handleAddWard
    }


};


export default useWardTableHook;
